import { Information } from "./information";
import { VibrationData } from "./vibration-data";

export class VibrationRecord {
    vibrationRecord: VibrationData;
    information: Information;
}